/**
 * AS-11681 — pure helpers for bulk delete on the PO list. Mirrors atlas's
 * useBulkDeletePOs so both apps report a batch the same way.
 */
import type { BulkDeletePoResult } from '@/collections/purchase_orders';

export interface BulkDeleteSummary {
  message: string;
  color: 'success' | 'warning';
}

/** "N deleted, M not deleted. PO-002: reason" — names each refused PO. */
export function summarizeBulkDelete(
  result: BulkDeletePoResult,
  purchaseOrders: { id: number; poNumber?: string }[],
): BulkDeleteSummary {
  const parts: string[] = [];
  if (result.successful.length > 0) { parts.push(`${result.successful.length} deleted`); }
  if (result.failed.length > 0) { parts.push(`${result.failed.length} not deleted`); }

  if (result.failed.length === 0) {
    return { message: `${parts.join(', ')}.`, color: 'success' };
  }
  const reasons = result.failed
    .map((f) => {
      const po = purchaseOrders.find((p) => p.id === f.id);
      return `${f.poNumber ?? po?.poNumber ?? f.id}: ${f.reason}`;
    })
    .join('; ');
  return { message: `${parts.join(', ')}. ${reasons}`, color: 'warning' };
}
